export default __webpack_public_path__ + "scripts/resource/9ab8035d17aea7c9ca4a4f9459023d64.svg";